import { render, staticRenderFns } from "./DashboardTotalItems.vue?vue&type=template&id=267dff2d&"
import script from "./DashboardTotalItems.vue?vue&type=script&lang=js&"
export * from "./DashboardTotalItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports